import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  tableDiv: {
    border: "1px",
  },
  link: {
    textDecoration: "none",
    color: "#3D63E6",
    cursor: "pointer",
  },
  label: {},
  textEnabled: { backgroundColor: "#fff" },
  dataTableDiv: {
    maxHeight: "calc(100vh - 290px)",
    //maxWidth: "calc(159vh)",
    border: "1px solid #C6C9CA",
    overflowY: "auto",
    overflowX: "auto",
    marginTop: "0px",
    background: "#F5F8FF",
  },
}));
